import PaymentMethodSummary from './PaymentMethodSummary'

export default PaymentMethodSummary
